// extracted by mini-css-extract-plugin
module.exports = {"productProblems":"ProductProblems_productProblems__tO_Jo","add":"ProductProblems_add__1Fnc7"};